import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ar from "./localization/ar.json";
import en from "./localization/en.json";

export const LANGUAGES = {
  en: { label: "English", dir: "ltr" },
  ar: { label: "العربية", dir: "rtl" },
};

const STORAGE_KEY = "businessLang";
const FALLBACK = "en";

/** ?lang= wins, then the saved choice, then the fallback. */
const initialLanguage = () => {
  const fromUrl = new URLSearchParams(window.location.search).get("lang");
  const saved = localStorage.getItem(STORAGE_KEY);
  const candidate = fromUrl || saved || FALLBACK;

  return LANGUAGES[candidate] ? candidate : FALLBACK;
};

/** Keeps <html lang/dir> in step so Tailwind's rtl: variants and logical
 *  utilities (ms-, me-, ps-, pe-) flip the whole layout. */
export const applyDirection = (language) => {
  const { dir } = LANGUAGES[language] ?? LANGUAGES[FALLBACK];
  document.documentElement.setAttribute("lang", language);
  document.documentElement.setAttribute("dir", dir);
};

i18n.use(initReactI18next).init({
  lng: initialLanguage(),
  fallbackLng: FALLBACK,
  interpolation: { escapeValue: false },
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
});

i18n.on("languageChanged", (language) => {
  localStorage.setItem(STORAGE_KEY, language);
  applyDirection(language);
});

// Persist the language chosen at boot as well — otherwise a ?lang= visit never
// fires languageChanged and the choice is lost on the next load.
localStorage.setItem(STORAGE_KEY, i18n.language);
applyDirection(i18n.language);

/**
 * Switch to the signed-in user's own language, through the same
 * `changeLanguage` the switcher uses (direction, storage, Accept-Language,
 * refetches and the push token all follow from it). A user who never chose a
 * language (null) keeps whatever the UI is already in.
 */
export const adoptUserLanguage = (user) => {
  const preferred = user?.preferred_language;
  if (LANGUAGES[preferred] && preferred !== i18n.language) i18n.changeLanguage(preferred);
};

export default i18n;
